import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';

import baseConfig from '../../config/baseConfig.js'
import "./Agenda.css"

function Agenda() {
    const agendaItemsSession1 = [
        {
            "time": "9:00-9:05",
            "speaker": "Zarząd Stowarzyszenia: Małgorzata Conti, Amanda Klęczek, Małgorzata Majer",
            "subject": "Powitanie uczestników i prelegentów",
            "icon": <i className="bi bi-door-open-fill"></i>,
            "class": "agendaItemOther"
        },
        {
            "time": "9:05-9:25",
            "speaker": "prof. dr hab. n. med. Dariusz Patkowski",
            "subject": "Ewolucja leczenia zarośnięcia przełyku - Polska na tle świata",
            "icon": <i className="bi bi-book"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "9:25-9:45",
            "speaker": "dr n. med. Aleksandra Jasińska",
            "subject": "Nowa metoda poszerzania przełyku stosowana w WUM",
            "icon": <i className="bi bi-book"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "9:45-10:05",
            "speaker": "prof. dr hab. n. med. Robert Śmigiel",
            "subject": "Jak rozumieć dziedziczność. Badania genetyczne w zarośnięciu przełyku",
            "icon": <i className="bi bi-book"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "10:05-10:25",
            "speaker": "dr hab. n. med. Dorota Waśko-Czopnik, prof. PWr",
            "subject": "Dorosły z atrezją przełyku - pytania i odpowiedzi",
            "icon": <i className="bi bi-book"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "10:25-10:40",
            "speaker": "",
            "subject": "Pytania",
            "icon": <i className="bi bi-person-raised-hand"></i>,
            "class": "agendaItemOther"
        },
        {
            "time": "10:40-11:00",
            "speaker": <><ul><li><strong>Warsztaty z udzielania pierwszej pomocy przy zakrztuszeniu</strong></li><li><strong>Konsultacja dorosłych osób z atrezją przełyku z gastroenterologiem</strong></li></ul></>,
            "subject": "Przerwa",
            "icon": <i className="bi bi-cup-hot-fill"></i>,
            "class": "agendaItemOther"
        }
    ];
    const agendaItemsSession2 = [
        {
            "time": "11:00-11:15",
            "speaker": "mgr Małgorzata Kałamejka",
            "subject": "Trudności w przetwarzaniu sensorycznym i karmieniu u dzieci z atrezją przełyku – implikacje dla terapii integracji sensorycznej",
            "icon": <i className="bi bi-book"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "11:15-11:35",
            "speaker": "mgr inż. Magdalena Ciężkowska",
            "subject": "Mniej presji, więcej odżywienia - praktyczne podejście do żywienia dzieci z atrezją przełyku",
            "icon": <i className="bi bi-book"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "11:35-11:55",
            "speaker": "mgr Katarzyna Warzeszak",
            "subject": "Fizjoterapia oddechowa w atrezji przełyku – wyzwania kliniczne i strategie postępowania",
            "icon": <i className="bi bi-book"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "11:55-12:15",
            "speaker": "dr n. kf. Przemysław Kędziora",
            "subject": "Blizna i co dalej?",
            "icon": <i className="bi bi-book"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "12:15-12:30",
            "speaker": "",
            "subject": "Pytania",
            "icon": <i className="bi bi-person-raised-hand"></i>,
            "class": "agendaItemOther"
        },
        {
            "time": "12:30-13:00",
            "speaker": <strong>Straż pożarna (na zewnątrz) - aż do końca konferencji</strong>,
            "subject": "Przerwa",
            "icon": <i className="bi bi-cup-hot-fill"></i>,
            "class": "agendaItemOther"
        }
    ];
    const agendaItemsSession3 = [
        {
            "time": "13:00-13:15",
            "speaker": "dr hab. n. med. i n. o zdr. Marcin Banasiuk",
            "subject": "Rola gastroenterologa dziecięcego w długoterminowej opiece nad pacjentem po operacji z powodu atrezji przełyku",
            "icon": <i className="bi bi-book"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "13:15-13:35",
            "speaker": "dr hab. Anna Rozensztrauch, prof. UMW",
            "subject": "Follow up - kiedy i do kogo należy się udać?",
            "icon": <i className="bi bi-book"></i>,
            "class": "agendaItemSubject"
        },
        // {
        //     "time": "13:35-13:55",
        //     "speaker": "dr n. med. Marcin Łosin",
        //     "subject": "Transition w chirurgii",
        //     "icon": <i className="bi bi-book"></i>,
        //     "class": "agendaItemSubject"
        // },
        {
            "time": "13:35-13:50",
            "speaker": "",
            "subject": "Pytania",
            "icon": <i className="bi bi-person-raised-hand"></i>,
            "class": "agendaItemOther"
        },
        {
            "time": "13:50-14:10",
            "speaker": "",
            "subject": "Podsumowanie konferencji i podziękowania",
            "icon": <i className="bi bi-megaphone-fill"></i>,
            "class": "agendaItemOther"
        },
        {
            "time": "14:10-16:00",
            "speaker": "",
            "subject": <>Część nieformalna: <ul><li>Integracja rodzin</li><li><strong>Warsztat fizjoterapii oddechowej</strong></li></ul></>,
            "icon": <i className="bi bi-people-fill"></i>,
            "class": "agendaItemOther"
        },
        {
            "time": "17:00-19:00",
            "speaker": "",
            "subject": "Kolacja (opcjonalnie)",
            "icon": <i className="bi bi-fork-knife"></i>,
            "class": "agendaItemOther"
        }
    ];

    const agendaItemsAdditional = [
        {
            "time": "Podczas konferencji",
            "subject": "Warsztaty z udzielania pierwszej pomocy",
            "icon": <i className="bi bi-arrow-right-short"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "",
            "subject": "Straż pożarna (na zewnątrz)",
            "icon": <i className="bi bi-arrow-right-short"></i>,
            "class": "agendaItemSubject"
        },
        {
            "time": "",
            "subject": "Możliwość zakupienia książki \"Wrodzone zarośnięcie przełyku: praktyczny przewodnik\"",
            "icon": <i className="bi bi-arrow-right-short"></i>,
            "class": "agendaItemSubject"
        }
    ];

    return (
        <>
            {baseConfig.displayAgenda ? (
                <>
                    {/* <Alert variant="info">
                        Program konferencji może ulec zmianie.
                    </Alert> */}
                    <Card className="agendaItem">
                        <Card.Header className="agendaSessionHeader1"><h3>Sesja I</h3></Card.Header>
                        <Card.Body>
                            {agendaItemsSession1.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Row>
                                        <Col xs={12} md={2} className="agendaItemTime">{item.time}</Col>
                                        <Col xs={12} md={10}>
                                            <span className="agendaItemIcon">{item.icon}</span>
                                            <span className={item.class}>{item.subject}</span><br />
                                            <span className="agendaItemSpeaker"> {item.speaker}</span>
                                        </Col>
                                    </Row>
                                    {index !== agendaItemsSession1.length - 1 && <hr />}
                                </React.Fragment>
                            ))}
                        </Card.Body>
                    </Card>
                    <Card className="agendaItem">
                        <Card.Header className="agendaSessionHeader2"><h3>Sesja II</h3></Card.Header>
                        <Card.Body>
                            {agendaItemsSession2.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Row>
                                        <Col xs={12} md={2} className="agendaItemTime">{item.time}</Col>
                                        <Col xs={12} md={10}>
                                            <span className="agendaItemIcon">{item.icon}</span>
                                            <span className={item.class}>{item.subject}</span><br />
                                            <span className="agendaItemSpeaker"> {item.speaker}</span>
                                        </Col>
                                    </Row>
                                    {index !== agendaItemsSession2.length - 1 && <hr />}
                                </React.Fragment>
                            ))}
                        </Card.Body>
                    </Card>
                    <Card className="agendaItem">
                        <Card.Header className="agendaSessionHeader3"><h3>Sesja III</h3></Card.Header>
                        <Card.Body>
                            {agendaItemsSession3.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Row>
                                        <Col xs={12} md={2} className="agendaItemTime">{item.time}</Col>
                                        <Col xs={12} md={10}>
                                            <span className="agendaItemIcon">{item.icon}</span>
                                            <span className={item.class}>{item.subject}</span><br />
                                            <span className="agendaItemSpeaker"> {item.speaker}</span>
                                        </Col>
                                    </Row>
                                    {index !== agendaItemsSession3.length - 1 && <hr />}
                                </React.Fragment>
                            ))}
                        </Card.Body>
                    </Card>
                    <Card className="agendaItem">
                        <Card.Header className="agendaSessionHeader4"><h3>Dodatkowo</h3></Card.Header>
                        <Card.Body>
                            {agendaItemsAdditional.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Row>
                                        <Col xs={12} md={2} className="agendaItemTime">{item.time}</Col>
                                        <Col xs={12} md={10}>
                                            <span className="agendaItemIcon">{item.icon}</span>
                                            <span className="">{item.subject}</span><br />
                                            <span className="agendaItemSpeaker"> {item.speaker}</span>
                                        </Col>
                                    </Row>
                                </React.Fragment>
                            ))}
                        </Card.Body>
                    </Card>
                </>
            ) : (
                <Alert variant="info">
                    Konferencja odbędzie w godzinach 9:00 - 15:00. <br />
                    Już wkrótce ogłosimy szczegółowy program. <br />

                </Alert>
            )}
        </>
    );
}

export default Agenda;